import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import { useI18n } from '@popety_io/popety-io-lib'

import { estimateSelector } from '../../redux'
import Echelleindex from './Echelleindex'
import AirQualitySummary from './AirQualitySummary'
import AQIGraph from './AQIGraph'

const EstimateAirQuality = () => {
  const { t } = useI18n()

  const estimate = useSelector(estimateSelector)

  const estimateAirQualityData = estimate?.estimateAirQualityData

  return (
    <Box>
      <Box
        position="sticky"
        top={0}
        pt={2}
        zIndex={10}
        bgcolor="background.paper"
      >
        <Box>
          <Typography variant="h2" fontSize="1.7rem" fontWeight={500}>
            {t('common.air_quality')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: '#969696',
              paddingBottom: '10px',
            }}
            fontSize="1rem"
          >
            {t('common.air_quality_description')}
          </Typography>
        </Box>
      </Box>
      <AirQualitySummary
        totalAverage={estimateAirQualityData?.data?.totalAverage}
        minAqi={estimateAirQualityData?.data?.minAqi}
        maxAqi={estimateAirQualityData?.data?.maxAqi}
      />
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          marginTop: '20px',
          marginBottom: '20px',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            width: { xs: '100%', md: '45%' },
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            paddingRight: { xs: 0, md: '20px' },
          }}
        >
          <Typography variant="h3" fontSize="1.2rem">
            {t('common.last_30_days_aqi')}
          </Typography>
          <AQIGraph
            data={estimateAirQualityData?.data?.statsPerDay}
            dateType="days"
          />
        </Box>
        <Box
          sx={{
            width: { xs: '100%', md: '45%' },
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            paddingRight: { xs: 0, md: '20px' },
          }}
        >
          <Typography variant="h3" fontSize="1.2rem">
            {t('common.daily_air_quality')}
          </Typography>

          <AQIGraph
            data={estimateAirQualityData?.data?.statsPerHour}
            dateType="hours"
          />
        </Box>
      </Box>

      <Echelleindex />
    </Box>
  )
}

export default EstimateAirQuality
